import { render } from "./attributes.vue?vue&type=template&id=75e09a31&scoped=true"
import script from "./attributes.vue?vue&type=script&lang=js"
export * from "./attributes.vue?vue&type=script&lang=js"

import "./attributes.vue?vue&type=style&index=0&id=75e09a31&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e09a31"]])

export default __exports__